import { Component } from '@angular/core';
import { Validators } from '@angular/forms';

//@Component({})

export class ValidationService {

    static ScheduleToEnroute(scheduleDate: Date, enRouteDate: Date) {

        if (scheduleDate === enRouteDate) {
        } else {
        }
    }

    //return date only dd/mm/yyyy
    static returnDateOnly(data: Date): Date {
        
        if (data != null) {
            data = new Date(data);

            let month = data.getMonth();
            let day = data.getDate();
            let year = data.getFullYear();

            let newDate = new Date(year, month, day, 0, 0, 0, 0);
            return newDate;
        }
        return null;
    }

    //time minutes round of 0,15,30,45
    static minutesIncrement(date1: Date): Date {
        
        let dateMonth = date1.getMonth();
        let dateDay = date1.getDate();
        let dateYear = date1.getFullYear();
        let timeHour = date1.getHours();
        let timeMinutes = date1.getMinutes();
        let timeSeconds = date1.getSeconds();
        let timeMilliSec = date1.getMilliseconds();
        timeSeconds = 0;
        if (timeMinutes == 0)
            timeMinutes = 0;
        else if (timeMinutes <= 15)
            timeMinutes = 15;
        else if (timeMinutes <= 30)
            timeMinutes = 30;
        else if (timeMinutes <= 45)
            timeMinutes = 45;
        else if (timeMinutes <= 59) {
            timeMinutes = 0;
            timeHour += 1;
        }
        return new Date(dateYear, dateMonth, dateDay, timeHour, timeMinutes, timeSeconds, timeMilliSec);
    }

    //current time minutes increment
    static addandMinusMinute(userDate: Date, option: string): Date {
        
        let dateMonth = userDate.getMonth();
        let dateDay = userDate.getDate();
        let dateYear = userDate.getFullYear();
        let timeHour = userDate.getHours();
        let timeMinutes = userDate.getMinutes();
        let timeSeconds = userDate.getSeconds();
        let timeMilliSec = userDate.getMilliseconds();
        timeSeconds = 0;
        timeMilliSec = 0;
        if (option === "add")
            timeMinutes += 15;
        else
            timeMinutes -= 15;
        let currNewDate: Date = new Date(dateYear, dateMonth, dateDay, timeHour, timeMinutes, timeSeconds, timeMilliSec);
        return currNewDate;
    }

    static addandMinusMinuts(userDate: Date, option: string): Date {
        
        if (option === "add") {
            if (userDate != null) {
                var minutesAdd = new Date(userDate);
                minutesAdd.setMinutes(minutesAdd.getMinutes() + 15);
                return minutesAdd;
            }
        } else {
            if (userDate != null) {
                var minutesAdd = new Date(userDate);
                minutesAdd.setMinutes(minutesAdd.getMinutes() - 15);
                return minutesAdd;
            }
        }
    }

    static ConcadinateDateAndTime(date1: Date, date2: Date): Date {
        if (date1 != null && date2 != null) {

            let dateMonth = date1.getMonth();
            let dateDay = date1.getDate();
            let dateYear = date1.getFullYear();

            let timeHour = date2.getHours();
            let timeMinutes = date2.getMinutes();
            let timeSeconds = date2.getSeconds();
            let timeMilliSec = date2.getMilliseconds();

            let newDate = new Date(dateYear, dateMonth, dateDay, timeHour, timeMinutes, 0, 0);
            return newDate;
        }
        return date1;
    }


    static currentTimeMinusMinuts(userDate: Date, option: string): Date {
        
        if (option === "add") {
            if (userDate != null) {
                var minutesAdd = new Date(userDate);
                minutesAdd.setMinutes(minutesAdd.getMinutes() + 15);
                return minutesAdd;
            }
        } else {
            if (userDate != null) {
                var minutesAdd = new Date(userDate);
                minutesAdd.setMinutes(minutesAdd.getMinutes() - 59);
                return minutesAdd;
            }
        }
    }

    static emailValidator(email: string) {
        
        if (!email.match(/[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/)) {
            return true;
        } else {
            return false;
        }
    }

    static mobileNoValidator(phone: string) {
        
        if (phone.match(/^\+?\d{2}[- ]?\d{3}[- ]?\d{5}$/)) {
            return false;
        } else {
            return true;
        }
    }

    static dayhourFormat(day: number, hour: number, min: number): any {
        
        var data = "";
        if (day !== null && day !== 0)
            data += day + ' day ';
        if (hour !== null && hour !== 0)
            data += hour + ' hr ';
        if (min !== null && min !== 0)
            data += min + ' mins ';
        return data;
    }

    static fullDayhourFormat(day: number, hour: number, min: number): any {
        
        var data = "";
        if (day !== null && day !== 0)
            data += day + ' Day ';
        if (hour !== null && hour !== 0)
            data += hour + ' Hour ';
        if (min !== null && min !== 0)
            data += min + ' Minutes ';
        return data;
    }

    static isEmpty(val) {
        
        return (val === undefined || val == null || val == "" || val.length <= 0 || val == '-' || val == 0 || val == NaN) ? true : false;
    }

    //return date only dd/mm/yyyy
    static returnDateTimeOnly(data: Date): Date {
        
        if (data != null) {
            data = new Date(data);

            let month = data.getMonth();
            let day = data.getDate();
            let year = data.getFullYear();
            let timeHour = data.getHours();
            let timeMinutes = data.getMinutes();
            let timeSeconds = data.getSeconds();
            let timeMilliSec = data.getMilliseconds();

            let newDate = new Date(year, month, day, timeHour, timeMinutes, 0, 0);
            
            return newDate;
        }
        return null;
    }

    static formatAMPM(date) {
        var hours = date.getHours();
        var minutes = date.getMinutes();
        var ampm = hours >= 12 ? 'pm' : 'am';
        hours = hours % 12;
        hours = hours ? hours : 12;
        minutes = minutes < 10 ? '0' + minutes : minutes;
        var strTime = hours + ':' + minutes + ' ' + ampm;
        return strTime;
    }

    static hourMinFormat(hour: number, min: number): any {
        
        var data = "";
        if (hour !== null && hour !== 0)
            data += hour + ' hr ';
        if (min !== null && min !== 0)
            data += min + ' mins ';
        return data;
    }
}